/* eslint-disable no-useless-constructor */
import React, { Component } from 'react'
import { MDBRow, MDBCol } from 'mdbreact';

class InputForm extends Component {
  render() {
    const { name, label, value, error } = this.props;

    return (
      <React.Fragment>
        <MDBRow>
          <MDBCol size="2">
            <label
              htmlFor={name}
              className="grey-text font-weight-light"
            >
              {label}
            </label>
          </MDBCol>
          <MDBCol>
            <input
              type={this.props.type ? this.props.type : "text"}
              id={name}
              className="form-control"
              value={value}
              name={name}
              onChange={this.props.onChange}
            />
          </MDBCol>
        </MDBRow>
        {error && <div className="alert alert-danger">
          {error}
        </div>}
      </React.Fragment>
    )
  }
}

export default InputForm;

